import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import Home from './pages/customer/Home';
import Login from './pages/auth/Login';
import Cart from './pages/customer/Cart';
import Search from './pages/customer/Search';
import AdminDashboard from './pages/admin/Dashboard';
import AdminOrders from './pages/admin/AdminOrders';
import EditProduct from './pages/admin/EditProduct';
import AdminProducts from './pages/admin/AdminProducts';
import ProductManagement from './pages/admin/ProductManagement';
import AdminRoute from './components/auth/AdminRoute';
import Checkout from './pages/customer/Checkout';
import ProductDetail from './pages/customer/ProductDetail';
import './styles/variables.css';
import './styles/globals.css';

function App() {
  return (
    <Router>
      <CartProvider>
        <AuthProvider>
          <div className="App">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/search" element={<Search />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/product/:slug" element={<ProductDetail />} />
              <Route path='/Checkout' element={<Checkout />} />
              {/* Rutas protegidas para admin */}
              <Route path="/admin/dashboard" element={
                <AdminRoute>
                  <AdminDashboard />
                </AdminRoute>
              } />
              <Route path="/admin/product-management" element={
                <AdminRoute>
                  <ProductManagement />
                </AdminRoute>
              } />
              <Route path='/admin/products' element={
                <AdminRoute>
                  <AdminProducts />
                </AdminRoute>
              } />
              <Route path='/admin/products/edit/:id' element={
                <AdminRoute>
                  <EditProduct />
                </AdminRoute>
              } />
              <Route path='/admin/orders' element={
                <AdminRoute>
                  <AdminOrders />
                </AdminRoute>
              } />
            </Routes>
          </div>
        </AuthProvider>
      </CartProvider>
    </Router>
  );
}

export default App;